import type {DateRangeSelection} from "@khan/component-date-range-dropdown";

import {ConversationsViewHeading} from "../conversation-view-heading.tsx";

import {GuideTranscriptsTableViewHeading} from "./guide-transcripts-table-view-heading.tsx";

interface Props {
    /**
     * Show the new table view instead of the conversations view
     */
    renderTableView?: boolean;
    /**
     * The title to display in the table view
     */
    tableTitle?: string;
    /**
     * Text which shows up aside from the title in the table view
     */
    tableBannerText?: string;
    /**
     * Whether filters should be shown
     */
    shouldShowFilters: boolean;
    /**
     * URL path to the user's profile, needed for conversation links
     */
    profilePath?: string;
    /**
     * The current date range selection
     */
    dateRangeSelection: DateRangeSelection;
    /**
     * Function to update the date range selection
     */
    setDateRangeSelection: React.Dispatch<
        React.SetStateAction<DateRangeSelection>
    >;
    /**
     * Whether to only show flagged threads
     */
    flaggedThreadsOnly: boolean;
    /**
     * Function to update the flagged threads filter
     */
    setFlaggedThreadsOnly: React.Dispatch<React.SetStateAction<boolean>>;
}

/**
 * Renders the appropriate heading based on view type.
 */
const GuideTranscriptsHeading = ({
    renderTableView,
    tableTitle,
    tableBannerText,
    shouldShowFilters,
    profilePath,
    dateRangeSelection,
    setDateRangeSelection,
    flaggedThreadsOnly,
    setFlaggedThreadsOnly,
}: Props): React.ReactNode => {
    if (renderTableView) {
        return (
            <GuideTranscriptsTableViewHeading
                tableTitle={tableTitle}
                tableBannerText={tableBannerText}
                shouldShowFilters={shouldShowFilters}
            />
        );
    }

    return (
        <ConversationsViewHeading
            profilePath={profilePath}
            dateRangeSelection={dateRangeSelection}
            setDateRangeSelection={setDateRangeSelection}
            flaggedThreadsOnly={flaggedThreadsOnly}
            setFlaggedThreadsOnly={setFlaggedThreadsOnly}
        />
    );
};

export {GuideTranscriptsHeading};
